import { createApi } from "@reduxjs/toolkit/query/react";
import { encryptedBaseQueryWithReauth } from "../utilities/encryptedBaseQuery";

export const salesAnalysticApi = createApi({
    reducerPath: "salesAnalysticApi",
    baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    // baseQuery: encryptedBaseQueryWithReauth(process.env.REACT_APP_LOCAL_URL),
    tagTypes: ["getSalesAnalysticList",],
    endpoints: (builder) => ({
        getSalesAnalysticList: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: ["getSalesAnalysticList"],
        }),

        getSalesAnalysticById: builder.query({
            query: (endpoint) => `${endpoint}`,
            providesTags: [""],
        }),

    }),


});



export const {
   
    useGetSalesAnalysticListQuery
  } = salesAnalysticApi;